/* esm.sh - applesauce-core@5.2.0/dist/helpers/expiration */
export * from "/*applesauce-core@5.2.0/esnext/dist/helpers/expiration.mjs";
